import { useSelector } from "react-redux"
import { useEffect, useState } from "react";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store"
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import LoadingComp from "../../components/re-usable/loading/loading";

const WorkForRaps = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const path = "Who-We-Are%2FWork-for-RAPS"; // who we are page content
  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}%2F${param.pageName}`));
    // dispatch(retrieveCurrentJobOpenings(`%2F${path}`))
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={`${path}%2F${param.pageName}`} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
      </TwoColumnLayOut>
    </>
  );
}

export default WorkForRaps;
